/**
 * @generated SignedSource<<4f7f2ca1ddd1bb98e43b5bcc9fb7e90d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgSpaceActiveInfoScreen_workspacePaginationQuery$variables = {
  after?: string | null;
  first?: number | null;
  id: string;
  spaceId: string;
};
export type OrgSpaceActiveInfoScreen_workspacePaginationQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"OrgSpaceActiveInfoScreen_workspace">;
  } | null;
};
export type OrgSpaceActiveInfoScreen_workspacePaginationQuery = {
  response: OrgSpaceActiveInfoScreen_workspacePaginationQuery$data;
  variables: OrgSpaceActiveInfoScreen_workspacePaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgSpaceActiveInfoScreen_workspacePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "OrgSpaceActiveInfoScreen_workspace"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "OrgSpaceActiveInfoScreen_workspacePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "spaceId"
                  }
                ],
                "concreteType": "StorecastSpace",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v7/*: any*/),
                    "concreteType": "SpaceActiveConnection",
                    "kind": "LinkedField",
                    "name": "stores",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SpaceActiveConnectionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SpaceActiveConnectionNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Store",
                                "kind": "LinkedField",
                                "name": "store",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "timezone",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "activeStorecastWithSpaceCount",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Dashboard",
                                "kind": "LinkedField",
                                "name": "activeDashboards",
                                "plural": true,
                                "selections": [
                                  (v6/*: any*/),
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cursor",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endCursor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasNextPage",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v7/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "OrgSpaceActiveInfoScreen_workspace_active_stores",
                    "kind": "LinkedHandle",
                    "name": "stores"
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Workspace",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3e52a7dff4c35a0b96afe06f1297795c",
    "id": null,
    "metadata": {},
    "name": "OrgSpaceActiveInfoScreen_workspacePaginationQuery",
    "operationKind": "query",
    "text": "query OrgSpaceActiveInfoScreen_workspacePaginationQuery(\n  $after: String\n  $first: Int\n  $spaceId: ID!\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...OrgSpaceActiveInfoScreen_workspace\n    id\n  }\n}\n\nfragment OrgSpaceActiveInfoScreenListItem_SpaceActiveConnectionNode on SpaceActiveConnectionNode {\n  store {\n    id\n    name\n    timezone\n  }\n  activeStorecastWithSpaceCount\n  activeDashboards {\n    id\n    name\n  }\n}\n\nfragment OrgSpaceActiveInfoScreen_workspace on Workspace {\n  id\n  space(id: $spaceId) {\n    stores(first: $first, after: $after) {\n      edges {\n        node {\n          ...OrgSpaceActiveInfoScreenListItem_SpaceActiveConnectionNode\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "a489cd5bf8790587525cc56b564ad2ae";

export default node;
